export default __webpack_public_path__ + "static/tip3-96dbdbc7ec11299554635c9027cd5040.png";